import type { ChangesEntry } from "@dashboard/shared/components/ChangesDialog";
import { Product } from "@products/types";

export const productChangesToEntries = (changes: Product["changes"] | null | undefined): ChangesEntry[] =>
    Object.entries(changes ?? {}).map(([version, versionChanges]) => ({ version, changes: versionChanges }));
